<div
  class="absolute bg-[#BFF4D2] h-full left-0 transition-all duration-700 w-0"
  [style.width.%]="
    isNumber(completedItems) && isNumber(totalItems)
      ? (completedItems! / totalItems!) * 100
      : 0
  "
></div>
@if (isNumber(completedItems) && isNumber(totalItems)) {
  <p
    class="relative flex gap-1 text-xs font-bold"
    >
    <span>{{ completedItems }}</span
      ><span>/</span><span>{{ totalItems }}</span>
      @if (showText) {
        <span class="font-medium">signature pages</span>
      }
    </p>
  }
